import { Head, useForm, Link, usePage } from '@inertiajs/inertia-react'
import { Card, Form, Button, Table, Alert, Row, Col, Modal, Spinner } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import Layout from '../../Shared/Layout/LayoutAdmin'
import AlertDismissible from '../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'

const Index = ({ metrics, advisers, currentMonth, currentYear, currentDay }) => {
    const { flash, errors } = usePage().props
    const { data, setData, post, processing, errors: formErrors } = useForm({
        adviser_id: '',
        year: currentYear,
        month: currentMonth,
        day: currentDay
    })
    const [showLoadingModal, setShowLoadingModal] = useState(false)

    const months = [
        { value: 1, label: 'Enero' },
        { value: 2, label: 'Febrero' },
        { value: 3, label: 'Marzo' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Mayo' },
        { value: 6, label: 'Junio' },
        { value: 7, label: 'Julio' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Septiembre' },
        { value: 10, label: 'Octubre' },
        { value: 11, label: 'Noviembre' },
        { value: 12, label: 'Diciembre' }
    ]

    const getFullName = (adviser) => {
        return `${adviser.user.name} ${adviser.lastname_ap} ${adviser.lastname_am}`.trim()
    }

    // Función para validar si un año es bisiesto
    const isLeapYear = (year) => {
        return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)
    }

    // Función para obtener el máximo de días válidos para un mes/año
    const getMaxDaysInMonth = (month, year) => {
        if ([1, 3, 5, 7, 8, 10, 12].includes(parseInt(month))) {
            return 31
        } else if ([4, 6, 9, 11].includes(parseInt(month))) {
            return 30
        } else if (month === 2 || month === '2') {
            return isLeapYear(parseInt(year)) ? 29 : 28
        }
        return 31
    }

    // Función para validar si la fecha es correcta
    const isValidDate = () => {
        if (!data.day || !data.month || !data.year) return false
        const maxDays = getMaxDaysInMonth(data.month, data.year)
        return parseInt(data.day) <= maxDays
    }

    // Efecto para cerrar el modal cuando termine el processing
    useEffect(() => {
        if (!processing) {
            setShowLoadingModal(false)
        }
    }, [processing])

    // Efecto para cerrar el modal cuando lleguen mensajes flash
    useEffect(() => {
        if (flash?.success || flash?.error) {
            setShowLoadingModal(false)
        }
    }, [flash])

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!isValidDate()) {
            return
        }
        setShowLoadingModal(true)
        post(route('commission-metrics.store'), {
            onError: () => {
                setShowLoadingModal(false)
            }
        })
    }

    const days = Array.from({ length: data.month && data.year ? getMaxDaysInMonth(data.month, data.year) : 31 }, (_, i) => i + 1)

    return (
        <>
            <Row>
                <div className="mb-7 mt-7">
                    <Breadcrumbs currentPath="/admin/commission-metrics" />
                </div>

                <Col className="mb-2 px-1">
                    <h2>Nueva Métricas de Comisiones por Agente</h2>
                </Col>

                {errors?.message && (
                    <AlertDismissible
                        message={errors.message}
                        type="danger"
                    />
                )}

                {flash?.success && (
                    <AlertDismissible
                        message={flash.success}
                        type="success"
                    />
                )}

                {flash?.error && (
                    <AlertDismissible
                        message={flash.error}
                        type="danger"
                    />
                )}

                <div className="card card-flush h-md-100">
                    <div className="card-body">
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label>Asesor</Form.Label>
                                <Form.Select
                                    value={data.adviser_id}
                                    onChange={e => setData('adviser_id', e.target.value)}
                                    isInvalid={formErrors?.adviser_id}
                                >
                                    <option value="">Seleccione un Field Trainer</option>
                                    {advisers.map(adviser => (
                                        <option key={adviser.id} value={adviser.id}>
                                            {getFullName(adviser)}
                                        </option>
                                    ))}
                                </Form.Select>
                                {formErrors?.adviser_id && <Form.Control.Feedback type="invalid">{formErrors.adviser_id}</Form.Control.Feedback>}
                            </Form.Group>

                            <Row>
                                <Col>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Día</Form.Label>
                                        <Form.Select
                                            value={data.day}
                                            onChange={e => setData('day', e.target.value)}
                                            isInvalid={formErrors?.day}
                                        >
                                            <option value="">Seleccione un día</option>
                                            {days.map(day => (
                                                <option key={day} value={day}>
                                                    {day}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {formErrors?.day && <Form.Control.Feedback type="invalid">{formErrors.day}</Form.Control.Feedback>}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Mes</Form.Label>
                                        <Form.Select
                                            value={data.month}
                                            onChange={e => setData('month', e.target.value)}
                                            isInvalid={formErrors?.month}
                                        >
                                            <option value="">Seleccione un mes</option>
                                            {months.map(month => (
                                                <option key={month.value} value={month.value}>
                                                    {month.label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {formErrors?.month && <Form.Control.Feedback type="invalid">{formErrors.month}</Form.Control.Feedback>}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Año</Form.Label>
                                        <Form.Select
                                            value={data.year}
                                            onChange={e => setData('year', e.target.value)}
                                            isInvalid={formErrors?.year}
                                        >
                                            <option value="">Seleccione un año</option>
                                            {Array.from({ length: new Date().getFullYear() - 1999 }, (_, i) => (
                                                <option key={2000 + i} value={2000 + i}>
                                                    {2000 + i}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {formErrors?.year && <Form.Control.Feedback type="invalid">{formErrors.year}</Form.Control.Feedback>}
                                    </Form.Group>
                                </Col>
                            </Row>

                            {data.day && data.month && data.year && !isValidDate() && (
                                <Alert variant="warning" className="mb-3">
                                    <i className="bi bi-exclamation-circle me-2"></i>
                                    La fecha seleccionada no es válida. {data.month === 2 || data.month === '2' ? 'Febrero' : 'El mes'} no tiene {data.day} días.
                                </Alert>
                            )}

                            <Button type="submit" disabled={processing || showLoadingModal || !isValidDate()}>
                                {processing ? 'Generando...' : 'Generar'}
                            </Button>
                        </Form>
                    </div>
                </div>

            </Row>

            {/* Modal de Loading */}
            <Modal
                show={showLoadingModal}
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body className="text-center py-5">
                    <Spinner animation="border" variant="primary" className="mb-3" />
                    <h5 className="mb-2">Generando métrica de comisiones...</h5>
                    <p className="text-muted mb-0">Por favor espere mientras procesamos la información</p>
                </Modal.Body>
            </Modal>
        </>
    )
}

Index.layout = page => <Layout children={page} title="Métricas de Comisiones" />

export default Index
